import React, {ReactElement} from "react";

import {css} from "/src/utils/utils";
import {MaybeType, SimpleFormProps} from "/src/types";
import {LOCALE} from "/src/config";

import Image, {ImageObject} from "../image/Image";
import SimpleFormWrapper from "../forms/simple-form-wrapper/SimpleFormWrapper";
import ModuleBody from "../layouts/module-body/ModuleBody";

import * as styles from "./email-subscribe.module.scss";
import {logGoogleAnalyticsEvent} from "/src/utils/google-analytics";

const WECHATQR =
  "https://images.ctfassets.net/92fo1e671z6m/5hd6DCS0ZRaJGZmZcLGXMo/f042602414e2b892b2c7ce12a8069c9f/Flexport-WeChat-QR-Code-for-website-only.jpeg";

export interface EmailSubscribeProps {
  copy: {
    title: string;
    description: string;
  };
  image?: MaybeType<ImageObject>;
  darkMode?: MaybeType<boolean>;
  subscriptionForm?: MaybeType<SimpleFormProps>;
}

interface FormData {
  email: string;
  "subscribe-term": string;
}

const EmailSubscribe = (props: EmailSubscribeProps): ReactElement => {
  const {copy, subscriptionForm, darkMode = false, image} = props;

  const [submitted, setSubmitted] = React.useState<boolean>(false);

  const hasImage = image != null;

  const onSubmit = async (data: FormData, err?: Error) => {
    if (err) {
      setSubmitted(false);
      return false;
    }

    logGoogleAnalyticsEvent(
      "send",
      "event",
      "Sign Up Behavior",
      "Submit Success",
      "Newsletter Sign Up"
    );

    setSubmitted(true);

    return true;
  };

  return (
    <section
      className={css(
        styles.emailSubscribe,
        darkMode ? styles.emailSubscribeDark : "",
        hasImage ? styles.emailSubscribeImage : ""
      )}
    >
      <ModuleBody classes={styles.emailSubscribe__body}>
        {copy.title && (
          <div className={css(styles.emailSubscribe__copy)}>
            {hasImage && (
              <div className={css(styles.emailSubscribe__imageWrapper)}>
                <Image
                  objectFit="contain"
                  image={image}
                  classes={styles.emailSubscribe__image}
                />
              </div>
            )}
            <h4
              className={css(
                hasImage ? "h1" : "h4",
                styles.emailSubscribe__title
              )}
            >
              {copy.title}
            </h4>

            {!hasImage && copy.description && (
              <p className={css("p", styles.emailSubscribe__desc)}>
                {copy.description}
              </p>
            )}
          </div>
        )}

        <div className={css(styles.emailSubscribe__formWrapper)}>
          {hasImage && (
            <p
              aria-hidden={submitted}
              className={css("p", styles.emailSubscribe__formDesc)}
            >
              {copy.description}
            </p>
          )}
          {LOCALE === "zh-CN" ? (
            <div className={styles.emailSubscribe__formQRWrapper}>
              <img
                className={css(styles.emailSubscribe__formQR)}
                alt="Flexport WeChat"
                src={WECHATQR}
              />
            </div>
          ) : (
            <>
              {subscriptionForm && (
                <SimpleFormWrapper
                  {...subscriptionForm}
                  onSubmitCallback={onSubmit}
                  classes={styles.emailSubscribe__form}
                  contentClasses={styles.emailSubscribe__formContent}
                  darkMode={darkMode}
                />
              )}
            </>
          )}
        </div>
      </ModuleBody>
    </section>
  );
};

export default EmailSubscribe;
